var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 4.688c-18.281 0-32.813 14.53-32.813 32.812C5.188 55.781 19.72 70.313 38 70.313c18.281 0 32.813-14.532 32.813-32.813C70.813 19.219 56.28 4.687 38 4.687zm0 60.937c-15.469 0-28.125-12.656-28.125-28.125S22.531 9.375 38 9.375 66.125 22.031 66.125 37.5 53.469 65.625 38 65.625z",
    fill: "#E10600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.656 53.906L38 41.25 25.344 53.906l-3.75-3.75L34.25 37.5 21.594 24.844l3.75-3.75L38 33.75l12.656-12.656 3.75 3.75L41.75 37.5l12.656 12.656-3.75 3.75z",
    fill: "#E10600"
  })));
}

export default SvgError;